export const SCREENSHARE_OFF = 'Screenshare Off';
export const SCREENSHARE_ON = 'Screenshare On';
export const SCREENSHARE_RESTART = 'Screenshare Restart';
export const SCREENSHARE_STARTED_WATCHING = 'Started Watching Screenshare'; // params: elementId
